import { render } from "./AdicionarAGrupoModal.vue?vue&type=template&id=66a77fb6&scoped=true"
import script from "./AdicionarAGrupoModal.vue?vue&type=script&lang=js"
export * from "./AdicionarAGrupoModal.vue?vue&type=script&lang=js"

import "./AdicionarAGrupoModal.vue?vue&type=style&index=0&id=66a77fb6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a77fb6"]])

export default __exports__